import React, { useState, useEffect, useRef } from "react";
import { MessageFactory } from "../../../lib/messages";
import { Protocol } from "../../../lib/constants";
import { Frame, ScalingContainer, Header } from "../../../AppStyled";

import Detailed from "./ProvFairDetailed";

import { Title, Button, SeedInput, Description, OPBox } from "./ProvFairStyled";
import { logger } from "../../../lib/logger";

export default ({
  pf,
  notifyText,
  handleNotification,
  handleAbove,
  Globals,
  unBlur,
  h,
  isClickable,
  isAutoOn,
  scrollable,
  userSettings,
}) => {
  const {
    client_seed,
    server_seed_SHA256,
    nonce,
    old_client_seed,
    old_server_seed,
    old_server_seed_SHA256,
    old_nonce,
    next_server_seed_SHA256,
  } = pf;
  const [inputSeed, setinputSeed] = useState("");
  const [seedError, setSeedError] = useState(false);

  const ProvFairTitle = {
    Title: "Explanation",
    Description: ` There are several implementations of the provably fair method, we
    will describe the most common one. With this method each roll-result
    is calculated by the following variables:`,
  };
  const ProvFairText = [
    {
      Title: "Serverseed",
      Description: `provided by the gambling site`,
    },
    {
      Title: "Nonce",
      Description: ` A number that increases with each random number is needed.`,
    },
    {
      Title: "Clientseed",
      Description: `provided by your browser and adjusted by you`,
    },
    {
      Title: "Hash",
      Description: `Encrypted data`,
    },
  ];

  const changeHandler = (e) => {
    let val = e.target.value;
    // const reg = /^[A-Za-z][A-Za-z0-9!@#$%^&*]*$/;
    const reg = /^[A-Za-z0-9]+$/;

    if (reg.test(val) || val === "") {
      setinputSeed(val);
    }
    if (val.length >= 16 && val.length <= 128) {
      handleNotification(false);
      setSeedError(false);
    }
  };
  const submit = () => {
    logger.log(Protocol.SET_SEED, inputSeed);
    if (inputSeed.length >= 16 && inputSeed.length <= 128) {
      Globals.WS.sendMessage(
        MessageFactory.createMessage(Protocol.SET_SEED, inputSeed)
      );
      handleNotification(false);
      setSeedError(false);
      setinputSeed("");
    } else {
      setSeedError(true);
      handleNotification(
        "Minimum length of seed must be 16 symbols and maximum - 128."
      );
    }
  };
  const [setA, setSetA] = useState(false);

  const setAnimation = (a, b) => {
    if (a) {
      b(false);
      clearTimeout();
    } else {
      b(true);
      setTimeout(() => {
        b(false);
      }, 500);
    }
  };
  const ClientseedRef = useRef(null);
  const Serverseed = useRef(null);
  const Nonce = useRef(null);
  const Oldclientseed = useRef(null);
  const Oldserverseed = useRef(null);
  const Oldserverseedhash = useRef(null);
  const Oldnonce = useRef(null);
  const nextServerseed = useRef(null);

  useEffect(() => {
    Globals.WS.sendMessage(MessageFactory.createMessage(Protocol.GET_SEEDS));
  }, [Globals.WS]);

  const copyToClipboard = (e) => {
    e.current.select();
    document.execCommand("copy");
    handleNotification("Copied to clipboard");
  };

  const VfCheck = () => {
    window.open('https://codepen.io/orbitalgaming/pen/poYbayx', '_blank')
  }

  return (
    <Frame className="Frame" unBlur={unBlur} scrollable={scrollable}>
      <ScalingContainer className="ScalingContainer" h={h} overflow>
        <OPBox>
          <Header
            name={"Prov. Fair"}
            handleAbove={handleAbove}
            userSettings={userSettings}
          />

          <Title>
            <h4>Clients seed</h4>
            {/* <p>{client_seed}</p> */}
            <textarea
              ref={ClientseedRef}
              onClick={() => copyToClipboard(ClientseedRef)}
              value={client_seed}
              spellCheck="false"
              readOnly="readOnly"
            />
          </Title>
          <Title>
            <h4>Server seed hash</h4>
            {/* <p>{server_seed_SHA256}</p> */}
            <textarea
              ref={Serverseed}
              onClick={() => copyToClipboard(Serverseed)}
              value={server_seed_SHA256}
              spellCheck="false"
              readOnly="readOnly"
            />
          </Title>
          <Title>
            <h4>Nonce</h4>
            {/* <p>{nonce}</p> */}
            <textarea
              ref={Nonce}
              onClick={() => copyToClipboard(Nonce)}
              value={nonce}
              spellCheck="false"
              readOnly="readOnly"
              className="nonce"
            />
          </Title>
          <Title>
            <h4>Next server seed hash</h4>
            <textarea
              ref={nextServerseed}
              onClick={() => copyToClipboard(nextServerseed)}
              value={next_server_seed_SHA256}
              spellCheck="false"
              readOnly="readOnly"
            />
          </Title>

          <form
            autoComplete="off"
            onSubmit={(e) => {
              e.preventDefault();
            }}
          >
            <SeedInput
              name="input"
              placeholder="New seed"
              spellCheck="false"
              onChange={changeHandler}
              value={inputSeed}
              // notify={
              //   (notifyText !== "Copied to Clipboard" &&
              //     notifyText &&
              //     !isClickable) ||
              //   isAutoOn
              // }
              notify={seedError}
              clickable={!isClickable}
              autoOn={isAutoOn}
            />
            <Button
              setA={setA}
              onClick={() => {
                setAnimation(setA, setSetA);
                setTimeout(() => {
                  submit();
                }, 200);
              }}
              clickable={!isClickable}
              autoOn={isAutoOn}
            >
              SET
            </Button>
          </form>
          <Title>
            <h4>Previous seed pair</h4>
          </Title>
          <Title copyCursor={old_client_seed === ""}>
            <h4>Clients seed</h4>
            <textarea
              ref={Oldclientseed}
              onClick={() =>
                old_client_seed !== "" && copyToClipboard(Oldclientseed)
              }
              value={old_client_seed !== "" ? old_client_seed : "clients seed"}
              spellCheck="false"
              readOnly="readOnly"
            />
          </Title>
          <Title copyCursor={old_server_seed === ""}>
            <h4>Server seed</h4>
            <textarea
              ref={Oldserverseed}
              onClick={() =>
                old_server_seed !== "" && copyToClipboard(Oldserverseed)
              }
              value={old_server_seed !== "" ? old_server_seed : "server seed"}
              spellCheck="false"
              readOnly="readOnly"
            />
          </Title>
          <Title copyCursor={old_server_seed_SHA256 === ""}>
            <h4>Server seed hash</h4>
            <textarea
              ref={Oldserverseedhash}
              onClick={() =>
                old_server_seed_SHA256 !== "" &&
                copyToClipboard(Oldserverseedhash)
              }
              value={
                old_server_seed_SHA256 !== ""
                  ? old_server_seed_SHA256
                  : "server seed hash"
              }
              spellCheck="false"
              readOnly="readOnly"
            />
          </Title>
          <Title copyCursor={old_nonce === "" || old_nonce === 0}>
            <h4>Nonce</h4>
            <textarea
              ref={Oldnonce}
              onClick={() => old_nonce !== "" && copyToClipboard(Oldnonce)}
              value={old_nonce}
              spellCheck="false"
              readOnly="readOnly"
            />
          </Title>
          <Button className={old_client_seed === "" || old_client_seed === undefined ? 'disabled':''}  onClick={() => VfCheck()}>Verify</Button>
          <Description>
            <h3>{ProvFairTitle.Title}</h3>
            <p>{ProvFairTitle.Description}</p>
          </Description>
          {ProvFairText.map((item, id) => (
            <Description key={id}>
              <h4>{item.Title}</h4>
              <p>{item.Description}</p>
            </Description>
          ))}
          <Detailed />
        </OPBox>
      </ScalingContainer>
    </Frame>
  );
};
